<template>
  <base-modal modal-content-class="modal_change_info modal_glow">
    <div class="content">
      <form @submit.prevent="changePin()">
        <h3 class="title">{{ getTranslations.home_modals_change_login_pin_text }}</h3>
        <base-password-form-input
          v-model="passwordOld"
          :label="getTranslations.home_modals_change_login_pin_enter_current"
          :invalid="hasErrors && showErrors"
          @keyup="checkPasswordOld"
        ></base-password-form-input>
        <div  class="error_text"
              v-show="hasErrors && showErrors">
          {{ getMessage(result) }}
        </div>

        <base-password-form-input
          v-model="passwordNew"
          :label="getTranslations.home_modals_change_login_pin_create_new"
          :invalid="hasErrors && showErrors"
          @keyup="checkPassword"
        ></base-password-form-input>
        <base-password-form-input
          v-model="confirmPassword"
          :label="getTranslations.home_modals_change_login_pin_confirm"
          :invalid="hasErrors && showErrors"
          @keyup="checkConfirmation"
        ></base-password-form-input>

        <div  class="error_text"
              v-show="hasErrors && showErrors">
          {{ getMessage(message) }}
        </div>

        <!-- We added the div element for https://velticloud.atlassian.net/browse/EXC-263 -->
        <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
          <a class="forgot_pin" @click.prevent="goToForgot()">
            {{ getTranslations.home_modals_change_login_pin_forgot }}
          </a>
        </div>

        <div class="outline_fancy_btn update_info">
          <button type="submit"
                  @click.prevent="changePin()"
                  :class="['fancy_btn', hasErrors || canProceed() ? '' : 'deactivated']">
            {{ getTranslations.home_modals_change_login_pin_update }}
          </button>
        </div>

        <p class="succ_upd" v-show="!hasErrors">
          {{ getMessage(result) }}
        </p>

      </form>
    </div>
  </base-modal>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import BasePasswordFormInput from "../../common/formInput/BasePasswordFormInput";
import BaseModal from "../../common/modal/BaseModal";

export default {
  name: 'change-login-pin',
  components: {
    BasePasswordFormInput,
    BaseModal,
  },
  data() {
    return {
      hasErrors: false,
      result: '',
      passwordOld: '',
      passwordNew: '',
      confirmPassword: '',
      validPasswordRegex: /^[0-9]{0,8}$/,
      showPinModal: false,
      showErrors: false,
    };
  },
  methods: {
    ...mapActions('profile', [
      'logoutUserFromAuthorizedPages',
    ]),
    goToForgot() {
      this.$router.push('/home/forgotPassword1');
    },
    canProceed() {
      return this.passwordOld && !this.hasErrors && this.passwordNew && this.confirmPassword;
    },
    checkMaxChar(value, max, evt) {
      if (value.length > max) {
        /*eslint-disable */
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode.which < 0x20) {
          // e.which < 0x20, then it's not a printable character
          // e.which === 0 - Not a character
          return;     // Do nothing
        }
        if (value.length === max) {
          charCode.preventDefault();
        } else if (value.length > max) {
          // Maximum exceeded
          return value.substring(0, max);
        }
        /* eslint-enable */
      }
    },
    changePin() {
      this.showErrors=false;
      if (!this.canProceed()) {
        if (!this.message) this.message = 'home_profile_profile_edit_msg_warning_invalid_password';
        this.hasErrors = true;
        this.showErrors = true;
      } else {
        this.message = '';
        this.$axios({
          url: 'api/changePassword',
          method: 'POST',
          headers: {
            Authorization: this.jwtInVuex,
          },
          data: {
            passwordOld: this.passwordOld,
            password: this.confirmPassword,
          },
        }).then((response) => {
          this.message = '';
          this.result = '';
          this.hasErrors = false;
          this.showErrors = false;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            this.result = 'home_profile_profile_edit_password_updated';
          } else if (response.data.responseEnum === 'SERVER_ERROR') {
            this.hasErrors = true;
            this.showErrors = true;
            this.result = 'home_profile_profile_edit_server_unvailable';
          } else {
            this.result = 'home_profile_profile_edit_msg_warning_invalid_password';
            this.hasErrors = true;
            this.showErrors = true;
          }
        }).catch((error) => {
          this.logoutUserFromAuthorizedPages();
          // eslint-disable-next-line
          console.log(`Invoking changePassword failed with the following error: ${error}`);
        });
      }
    },
    checkConfirmation(evt) {
      if (this.confirmPassword) {
        this.result = '';
        const min = 4;
        const max = this.maximumDigitsPinLength;
        const validPass = this.confirmPassword.match(this.validPasswordRegex);
        this.hasErrors = false;
        this.message = '';
        if (this.confirmPassword.length < min) {
          this.hasErrors = true;
        } else if (this.confirmPassword.length > max) {
          this.confirmPassword = this.checkMaxChar(this.confirmPassword, max, evt);
          this.hasErrors = true;
          this.checkConfirmation();
        } else if (validPass !== null) {
          if (this.confirmPassword.length > max) {
            this.confirmPassword = this.checkMaxChar(this.confirmPassword, max, evt);
            this.hasErrors = true;
            this.checkConfirmation();
          }
          if (this.confirmPassword === '' || (this.confirmPassword === this.passwordNew)) {
            this.hasErrors = false;
          } else {
            this.message = 'home_profile_profile_edit_msg_warning_entered_passwords_not_match';
            this.hasErrors = true;
          }
        } else if (validPass === null) {
          this.hasErrors = true;
          this.message = 'home_profile_profile_edit_msg_password_cannot_contain_any_other_symbols_except_from_';
        }
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    checkPasswordOld() {
      if (this.passwordOld) {
        const min = 4;
        const max = 12;
        this.hasErrors = false;
        this.message = '';
        this.result = '';
        if (this.passwordOld.length < min || this.passwordOld.length > max) {
          this.message = 'home_profile_profile_edit_wrong_password_warning_msg_at_least_6_chars';
          this.hasErrors = true;
        }
      }
    },
    checkPassword(evt) {
      if (this.passwordNew) {
        const min = 4;
        const max = this.maximumDigitsPinLength;
        const validPass = this.passwordNew.match(this.validPasswordRegex);
        this.message = '';
        this.hasErrors = false;
        if (this.passwordNew.length < min) {
          this.message = 'home_profile_profile_edit_wrong_password_warning_msg_at_least_6_chars';
          this.hasErrors = true;
        } else if (this.passwordNew.length > max) {
          this.passwordNew = this.checkMaxChar(this.passwordNew, max, evt);
          this.hasErrors = true;
          this.checkPassword();
        } else if (validPass !== null) {
          if (this.passwordNew.length > max) {
            this.passwordNew = this.checkMaxChar(this.passwordNew, max, evt);
            this.hasErrors = true;
            this.checkPassword();
          }
          if (this.confirmPassword === '' || (this.confirmPassword === this.passwordNew)) {
            this.hasErrors = false;
          } else {
            this.message = 'home_profile_profile_edit_msg_warning_entered_passwords_not_match';
            this.hasErrors = true;
          }
        } else if (validPass === null) {
          this.hasErrors = true;
          this.message = 'home_profile_profile_edit_msg_password_cannot_contain_any_other_symbols_except_from_';
        }
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslations[key] || '';
    },
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.prof_edit_opt_box,.overlay').fadeIn(200);
        // show/hide modal
        $('.btn_close, .overlay').click(function () {
          vm.$emit('close');
          $('#changeLoginPin').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'maximumDigitsPinLength',
    ]),
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ChangeLoginPin.vue